<template>
  <div>
    <div class="animated slideInRight">
        <div class="row">
            <div class="col">
                <div class="m-3">
                    <table class="table table-bordered table-responsive w-100 d-block d-md-table">
                        <thead>
                            <tr>
                                <th>Description</th>
                                <th>No of Items</th>
                                <th>Weight (KG)</th>
                                <th>Length (CM)</th>
                                <th>Width (CM)</th>
                                <th>Height (CM)</th>
                                <th>
                                    <div class="text-center text-white">
                                        <a class="btn btn-info" v-on:click="addItem"><span class="icon is-small"><i class="fa fa-plus"></i></span></a>
                                    </div>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, key, index) in state.items" :key="index">
                                <td><input type="text" v-model="item.desc" placeholder="Item Description" class="form-control" style="min-width: 150px;"></td>
                                <td><input type="number" v-model="item.qty" placeholder="No of Items" class="form-control"></td>
                                <td><input type="number" v-model="item.weight" placeholder="Weight (KG)" class="form-control"></td>
                                <td><input type="number" v-model="item.length" placeholder="Length (CM)" class="form-control"></td>
                                <td><input type="number" v-model="item.width" placeholder="Width (CM)" class="form-control"></td>
                                <td><input type="number" v-model="item.height" placeholder="Height (CM)" class="form-control"></td>
                                <td><a class="btn btn-danger text-white" v-on:click="removeItem(key)"><span class="icon"><i class="fa fa-minus"></i></span></a></td>
                            </tr>
                        </tbody>
                    </table>
                    <div class="row">
                        <div class="col">
                            <p>Please confirm this information is correct. If it is not please contact the receiver.</p>
                            <button class="btn btn-primary float-right" data-toggle="modal" data-target="#confirmItemModal">Continue</button>
                            <button class="btn btn-danger float-right mr-2" v-on:click="goToRoot">Cancel</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <template v-if="state.items.length === 0">
                    <div class="alert alert-info"><p>Use the Add button to add items to this consignment</p></div>
                </template>
            </div>
        </div>
        <br>
    </div>
    <!-- Modal -->
      <div class="modal fade" id="confirmItemModal" tabindex="-1" role="dialog" aria-labelledby="confirmItemModal" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="confirmItemLabel">Confirming Items</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <p>I confirm this information is correct. If it is not please contact the receiver.</p>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-danger" data-dismiss="modal">Close</button>
              <button type="button" class="btn btn-primary" @click="tryGoToNextStep()" data-dismiss="modal">Confirm</button>
            </div>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
    import Step from '@/mixins/step'

    export default {
        mixins: [ Step ],
        name: 'StepItems',
        methods: {
            /**
             * Removes an items from this.state.items
             *
             * @param Integer index The index to remove
             */
            removeItem: function (index) {
                this.state.items.splice(index, 1)
            },
            /**
             * Add Item
             *
             * Add's a blank row to items
             */
            addItem: function () {
                let newItem = {}

                // Add all the items arrays
                this.state.fieldsForItems.forEach(function (fieldValue) {
                    newItem[fieldValue] = null
                })
                // Let's set default values
                newItem.qty = 1
                // Add it to items
                this.state.items.push(newItem)
            },
            tryGoToNextStep () {
              // Clear previous error messages
              this.state.messages.clearMessages()
              // Validation Result
              let validationResult = true

              // First check we've actually added some items..
              if (this.state.items.length) {
                  // Because "this" changes inside our callback we'll use "that"
                  const that = this
                  // Let's check each field if it has every field entered
                  this.state.items.forEach(function (item) {
                      // For each required field
                      that.state.requiredFieldsForItems.forEach(function (requiredFieldName) {
                          // If this fields value equates to being false
                          if (!item[requiredFieldName]) {
                              // Most likely it's empty or null...
                              that.state.messages.addMessage('Please ensure all ' + requiredFieldName + '\'s are entered', 0)
                              // Don't let us go to the next step just yet..
                              validationResult = false
                          }
                      })
                  })
              } else {
                  // Most likely it's empty or null...
                  this.state.messages.addMessage('Please add an item', 0)
                  // Don't let us go to the next step just yet..
                  validationResult = false
              }

              // Return the actual result
              if (validationResult) {
                  this.goToNextStep()
              }
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    .table {
        th {
            vertical-align: middle;
            text-align: center;
        }
    }
</style>
